<template>
  <div style="min-width: 260px">
    <ClientHeader :cid="cid" :sid="sid"/>
    <section class="top-wrap top-wrap-masters">
      <div class="container">
        <i class="material-icons" @click="navigateBefore()">chevron_left</i>
        <div class="top-wrap__headers">
          <h2 class="top-wrap__title">{{ serviceName }}</h2>
          <!--<h2 class="top-wrap__title">Базовый</h2>-->
        </div>
        <!--
        <form action="#" class="top-wrap__form">
          <input type="text" class="top-wrap__input" placeholder="Поиск" />
          <button class="top-wrap__btn" type="button">
            <i class="material-icons">search</i>
          </button>
        </form>
        -->
      </div>
    </section>
    <section class="client-masters" style="min-width: 260px">
      <div class="container" style="min-width: 260px">
        <div class="client-masters__head">
          <h2 class="client-masters__subtitle">
            {{ (serviceMasters && serviceMasters.length && serviceMasters.length > 1 ? 'Сотрудники работают ' :
            'Сотрудник работает ') + localeDate}}
          </h2>
          <div class="client-masters__date">
            <div class="client-masters__date-label">
              <i class="material-icons">calendar_today</i>
            </div>
            <!-- <input
              type="text"
              value="Выбрать дату"
              @click="triggerDateSelect()"
              id="triggerDate"
              readonly
            >-->
            <date-pick
                :value="serviceInProgress.date"
                @input="setCurrentDate"
                :inputAttributes="{readonly: true}"
                :isDateDisabled="isDateDisabled"
                :highlightDates="selectedDates"
            />
            <!-- <datepicker :value="'Выбрать дату'"></datepicker> -->
          </div>
        </div>

        <!-- <Masters /> -->
        <loading :active.sync="isLoading"></loading>

        <div v-if="serviceMasters && serviceMasters.length === 0" style="padding: 10px;">Нет доступных мастеров</div>

        <div
            v-if="currentMasterIsActive"
            class="client-masters-item single"
            :class="{'mobile' : isMobile}"
        >
          <img
              v-if="currentMaster && currentMaster.photo != null"
              :src="SERVER_URL+currentMaster.photo"
              alt
              class="client-masters-item__img"
          />
          <img v-else alt src="../assets/img/Group_2.svg" class="client-masters-item__img"/>
          <h3 class="client-masters-item__name">{{currentMaster.full_name}}</h3>
        </div>

        <div v-if="!isLoading && (!isMobile && slides.length)" style="min-width: 260px">
          <swiper :options="swiperOption" ref="mySwiper" style="min-width: 260px">
            <!-- slides -->
            <swiper-slide :key="index" v-for="(master, index) in slides" style="min-width: 260px">

              <div
                  v-if="!master.adsenseContent"
                  @click="setCurrentMasterId(master)"
                  class="client-masters-item" :class="{'mobile' : isMobile}">
                <img
                    v-if="master && master.photo != null"
                    :src="SERVER_URL+master.photo"
                    alt
                    class="client-masters-item__img"
                />
                <img v-else alt src="../assets/img/Group_2.svg" class="client-masters-item__img"/>
                <h3 class="client-masters-item__name">{{master.full_name}}</h3>

                <!-- TODO: commented out this while rate will be
                <div class="client-masters-item__stars">
                <span class="client-masters-item__star" id="star1">
                <i class="material-icons">star</i>
                </span>
                <span class="client-masters-item__star" id="star2">
                <i class="material-icons">star</i>
                </span>
                <span class="client-masters-item__star" id="star3">
                <i class="material-icons">star</i>
                </span>
                <span class="client-masters-item__star" id="star4">
                <i class="material-icons">star</i>
                </span>
                <span class="client-masters-item__star" id="star5">
                <i class="material-icons">star</i>
                </span>
                </div>
                -->
                <!--<div class="client-masters-item__tags">-->
                <!--<div class="client-masters-item__tag">Базовый</div>-->
                <!--<div class="client-masters-item__tag">V.I.P.</div>-->
                <!--<div class="client-masters-item__tag">Бизнес</div>-->
                <!--</div>-->
              </div>
              <div v-if="master.adsenseContent" class="client-masters-item ads" :key="index+'_adv'">
                <adsense
                    :key="index+'_adv'"
                    adClient="ca-pub-3132918828120911"
                    adLayout="-6t+ed+2i-1n-4w"
                    adSlot="8544859809"
                    adFormat="fluid"
                    adStyle="display:block;min-width:298px;max-width:300px;width:100%;height:300px;margin: 0 auto;"
                >
                </adsense>
              </div>
            </swiper-slide>
          </swiper>
        </div>

        <div v-if="!isLoading && (isMobile && slides.length)" style="min-width: 260px">
          <div :key="index" v-for="(master, index) in slides" style="min-width: 260px">
            <div
                v-if="!master.adsenseContent"
                @click="setCurrentMasterId(master)"
                class="client-masters-item" :class="{'mobile' : isMobile}">
              <img
                  v-if="master && master.photo != null"
                  :src="SERVER_URL+master.photo"
                  alt
                  class="client-masters-item__img"
              />
              <img v-else alt src="../assets/img/Group_2.svg" class="client-masters-item__img"/>
              <h3 class="client-masters-item__name">{{master.full_name}}</h3>
            </div>
            <div v-if="master.adsenseContent" class="client-masters-item ads" :key="index+'_adv'">
              <adsense
                  :key="index+'_adv'"
                  adClient="ca-pub-3132918828120911"
                  adLayout="-6t+ed+2i-1n-4w"
                  adSlot="8544859809"
                  adFormat="fluid"
                  adStyle="display:block;min-width:298px;max-width:300px;width:100%;height:300px;margin: 0 auto;"
              >
              </adsense>
            </div>
          </div>
        </div>

        <button
            class="current-master__back-mobile"
            :class="{'is-active': currentMasterBackMobile}"
            type="button"
            @click="onClickBack"
        >
          <span>Назад</span>
        </button>
        <!-- Info about master -->
        <OneMasterInfo :sid="sid" :cid="cid" :isActive="currentMasterIsActive" @onClickBack="onClickBack"/>
      </div>
    </section>
  </div>
</template>
<script>
import ClientHeader from '@/components/ClientHeader.vue';
//import Masters from '@/components/Masters.vue'
import {swiper, swiperSlide} from 'vue-awesome-swiper';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import OneMasterInfo from '@/components/OneMasterInfo/OneMasterInfo.vue';
import DatePick from '../vendor/vue-date-pick/vueDatePick.vue';
import Datepicker from 'vuejs-datepicker';
import '../vendor/vue-date-pick/vueDatePick.css';
import * as moment from 'moment';
import 'moment/locale/ru';
import {mapState, mapGetters, mapMutations, mapActions} from 'vuex';
import Adsense from '@/components/ADSENSE/Adsense.vue';
import {isMobileDevice} from "../helpers/osChecker";

export default {
  name: 'client-masters',
  props: ['sid', 'cid'],
  data() {
    return {
      masterSlider: undefined,
      adsenseContent: false,
      mobilePoint: 600,
      currentMasterIsActive: false,
      clientMastersSlider: false,
      currentMasterBackMobile: false,
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 10,
        mousewheel: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        freeMode: true,
        // loop: true,
        // loopFillGroupWithBlank: true,
        breakpoints: {
          900: {
            slidesPerView: 2,
          },
          600: {
            slidesPerView: 1,
          }
        }
      },
      el: null,
      mobileSwiperOption: {
        direction: 'vertical',
        slidesPerView: 'auto',
        freeMode: true,
        spaceBetween: 15,
        scrollbar: {
          el: '.swiper-scrollbar'
        },
        mousewheel: true
      },
      restartSwiper: false,
      currentMaster: {}
    };
  },
  components: {
    ClientHeader,
    //Masters,
    OneMasterInfo,
    Loading,
    DatePick,
    Datepicker,
    swiper,
    swiperSlide,
    Adsense
  },
  methods: {
    ...mapMutations('client', ['setServiceInProgressData', 'setDate']),
    ...mapActions('salons', ['fetchSalonServiceMasters']),
    navigateBefore() {
      this.$router.push('/company/' + this.cid + '/client-service');
    },
    slideTo(id) {
      let index = this.slides && this.slides.findIndex(el => parseInt(el.id) === parseInt(id));
      this.$refs && this.$refs.mySwiper && this.$refs.mySwiper.swiper.slideTo(index, 1000, false);
    },
    setCurrentMasterId(master) {
      this.slideTo(master.id);
      this.currentMaster = master;

      this.currentMasterIsActive = true;
      if (!this.isMobile) {
        this.clientMastersSlider = false;
      } else {
        this.clientMastersSlider = true;
        this.currentMasterBackMobile = true;
      }
      this.setServiceInProgressData({masterId: master.id});
    },
    onClickBack() {
      this.currentMasterIsActive = false;
      this.clientMastersSlider = false;
      this.currentMasterBackMobile = false;
    },
    setCurrentDate(date) {
      this.setServiceInProgressData({date});
      const {serviceId} = this.serviceInProgress;

      this.fetchSalonServiceMasters({
        salonId: this.currentSalonId,
        serviceId,
        date
      });
    },

    isDateDisabled(date) {
      const currentDate = new Date(Date.now() - 1000 * 60 * 60 * 24);
      const futureDate = new Date(Date.now() + 1000 * 60 * 60 * 24 * 21);
      return date > futureDate || date < currentDate;
    },
    randomInteger(min, max) {
      let rand = min + Math.random() * (max + 1 - min);
      return Math.floor(rand);
    }
  },
  computed: {
    ...mapGetters('salons', [
      'getSalonMasters',
      'getService',
      'getSubService',
      'getConcreteService'
    ]),
    ...mapState('client', [
      'serviceInProgress',
      'currentSalonId',
      'date',
      'selectedServices',
      'companyId',
      'companySettings'
    ]),
    ...mapState('salons', ['serviceMasters']),
    ...mapGetters('client', ['getCustomer', 'getServices']),
    masters() {
      return this.getSalonMasters(this.currentSalonId);
    },
    slides() {
      if (!this.serviceMasters) return [];
      //all adsenseContent variables turn to false
      let ret = this.serviceMasters.slice(); // clone the salons list
      // if (this.el) {
      //   const positions = this.advPositions && this.advPositions.sort((a,b) => a - b).reverse();
      //   // let hasAds = ret && ret.filter(e => e.adsenseContent)
      //   // reverse - чтобы вставлять с конца, чтобы индексы не сбивались
      //   // if((positions && positions.length) && !hasAds.length) {
      //   //   for (let x of positions){
      //   //     //all adsenseContent variables turn to false
      //   //     ret.splice(x, 0, {adsenseContent: false})
      //   //   }
      //   // }
      // }
      return ret;
    },
    isMobile() {
      return isMobileDevice();
    },
    cSwiperOption() {
      return this.isMobile ? this.mobileSwiperOption : this.swiperOption;
    },
    concreteService() {
      const {
        serviceId,
        subServiceId,
        concreteServiceId
      } = this.serviceInProgress;
      return this.getConcreteService(
        this.currentSalonId,
        serviceId,
        subServiceId,
        concreteServiceId
      );
    },
    serviceName() {
      return this.concreteService ? this.concreteService.name : '';
    },
    localeDate() {
      return moment(this.serviceInProgress.date).format('LL');
    },
    isLoading() {
      return this.serviceMasters === undefined;
    },
    selectedDates() {
      let dates = [];
      // this.selectedServices.forEach(element => {
      //   dates.push(element.date);
      // });
      return dates;
    },
    advPositions() {
      // возвращает список позиций в списке, на которые вкорячиваем реккламу. zero-based.
      if (!this.companySettings.is_enabled_adv)
        return [];
      if (!this.serviceMasters || this.serviceMasters.length === 0) {
        // нет филиалов - нет рекламы
        return [];
      }
      if (this.serviceMasters.length === 0) {
        return [];
      }
      else if (this.serviceMasters.length === 1) {
        // 1 филиал - вставляем рекламу после него
        return [1];
      }
      else if (this.serviceMasters.length === 2) {
        // два филиала - между первым и вторым
        return [1];
      }
      else if (this.serviceMasters.length > 2) {
        // три и более филиала - после второго и где-нибудь ещё
        let random = this.randomInteger(2, this.serviceMasters.length);
        return [1, random];
      }
    },
  },
  watch: {
    cSwiperOption(val, old) {
      this.restartSwiper = true;
      this.$nextTick(() => {
        this.restartSwiper = false;
      });
    },
  },
  mounted: async function () {
    this.el = this.$el;
    const {serviceId, date} = this.serviceInProgress;
    this.setDate(this.date);
    if (this.currentSalonId && serviceId && date) {
      await this.fetchSalonServiceMasters({
        salonId: this.currentSalonId,
        serviceId,
        date
      });
    }
    moment.locale('ru');
  },
  beforeMount() {
    let isGender = (this.companySettings && this.companySettings.is_genderable_services) ? (this.getCustomer && this.getCustomer.gender) : true;
    if (!(this.currentSalonId && isGender && (this.getServices && this.getServices.serviceId)))
      return this.$router.replace(`/company/${this.$route.params.cid}`);
  }
};
</script>
<style lang="sass">
  // width
  =r($width)
    @media only screen and (max-width: $width+ "px")
      @content

  =rmin($width)
    @media only screen and (min-width: $width+ "px")
      @content

  // height
  =rh($height)
    @media only screen and (max-height: $height + "px")
      @content

  =rhmin($height)
    @media only screen and (min-height: $height + "px")
      @content
  // LAYOUT
  $mobile-s: 375
  $mobile: 568
  $tablet: 767
  $desktop: 992
  $wide: 1336
  $hd: 1440

  // COLORS
  $text-18: #181818
  $text-36: #363636

  // OPTIONS
  $transitSpeed: .2s
  $ease: ease-in-out

  .vdpInnerWrap
    border: 0
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.1)

  .vdpHeader
    background-color: #fff

  .vdpArrowPrev:after
    border-right-color: $text-18

  .vdpArrowNext:after
    border-left-color: $text-18

  .vdpHeadCellContent
    color: $text-18

  .vdpCell.selected .vdpCellContent
    background-color: #fff
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.1)
    color: $text-18

  .vdpCell.selectable:hover .vdpCellContent
    background-color: #fff
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.1)
    color: $text-18

  .vdpCellContent
    border-radius: 4px

  .vdpComponent.vdpWithInput
    z-index: 1

  .vdpComponent.vdpWithInput > input
    display: inline-block
    padding-right: 0
    border: 0
    border-radius: 8px
    background-color: $text-36
    text-align: center
    color: #fff
    size: auto
    font-size: 20px
    width: 127px
    padding: 4px 12px

  .vdpWithInput > button
    visibility: hidden
    opacity: 0

  .top-wrap-masters
    i
      display: none
      position: absolute
      left: 10px
      top: 50%
      transform: translateY(calc(-50% - 2px))
    .top-wrap__title
      margin-right: 20px
      color: $text-18
      &:last-child
        margin-right: 0
    .top-wrap__form
      min-width: 375px

  .client-masters
    .container
      height: calc(100vh - 160px)
      position: relative
    &__head
      padding-top: 15px
      display: -webkit-flex
      display: -ms-flex
      display: flex
      justify-content: space-between
      align-items: center
      margin-bottom: 20px
      position: relative
      z-index: 17
    &__subtitle
      margin: 0
      font-size: 20px
      font-weight: 500
      color: $text-18
      margin-right: auto
    &__date-label
      position: absolute
      font-size: 20px
      color: $text-36
      padding-right: 25px
      margin-right: 30px
      i
        position: absolute
        top: 6px
        font-size: 20px
        z-index: 0
        right: 40px
    &__date
      position: relative
      font-size: 20px
      font-weight: 400
      color: $text-36
      #triggerDate
        display: inline-block
        padding-right: 0
        border: 0
        border-radius: 8px
        background-color: #363636
        text-align: center
        color: #fff
        size: auto
        font-size: 20px
        width: 180px
        padding: 4px 12px
        position: absolute
        right: 0
        z-index: 1000
      .vdpComponent
        &.vdpWithInput
          > input
            cursor: pointer
            width: 180px
      .vdpCell
        &.selected, &.selectable:hover
          .vdpCellContent
            background-color: rgb(54, 54, 54)
            color: #ffffff
    &__slider
      display: -webkit-flex
      display: -ms-flex
      display: flex
      align-items: stretch
      justify-content: flex-start
      margin-left: -12px
      margin-right: -12px
      .owl-item
        padding: 10px
      .slick-list
        padding: 10px 35px 10px 0 !important
      .slick-prev,
      .slick-next
        font-size: 16px
        line-height: 18px
        width: auto
        height: auto
        z-index: 5
        top: calc(100% + 20px)
        transform: none
        i
          position: absolute
          top: 50%
          transform: translateY(-50%)
      .slick-prev
        padding-left: 25px
        left: 5px
        i
          left: 0
      .slick-next
        padding-right: 25px
        right: 5px
        i
          right: 0

  .client-masters-item
    min-width: 260px
    min-height: 260px
    max-height: 350px
    background-color: #fff
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.1)
    border-radius: 8px
    padding-bottom: 15px
    overflow: hidden
    margin-right: 12px
    margin-left: 12px
    position: relative
    &.single
      width: 298px
      position: absolute
      z-index: 99
    &:hover
      cursor: pointer
      background-color: #181818
      .client-masters-item__name
        color: #fff
      .client-masters-item__star
        i
          color: #fff
    &__img
      display: block
      height: auto
      width: 100%
      min-height: 270px
      max-height: 300px
      object-fit: cover
    &__name
      font-size: 14px
      margin-top: 10px
      margin-bottom: 5px
      padding: 0 15px
      font-weight: 400
      color: $text-18
    &__stars
      display: -webkit-flex
      display: -ms-flex
      display: flex
      justify-content: flex-start
      align-items: center
      margin-bottom: 15px
      padding: 0 15px
    &__star
      margin-right: 5px
      opacity: 0.5
      &:last-child
        margin-right: 0
      &--full
        opacity: 1
      i
        font-size: 16px
        color: $text-18
    &__tags
      display: -webkit-flex
      display: -ms-flex
      display: flex
      align-items: stretch
      justify-content: flex-start
      padding: 0 15px
    &__tag
      background-color: $text-18
      color: #fff
      text-align: center
      font-size: 10px
      text-transform: uppercase
      font-weight: 400
      padding: 5px
      border-radius: 4px
      margin-right: 10px
      &:last-child
        margin-right: 0

  .current-master
    position: absolute
    top: 65px
    left: 340px
    background-color: #fff
    border-radius: 8px
    box-shadow: 5px 0 10px rgba(0, 0, 0, 0.07)
    padding: 20px 30px 20px 5px
    display: -webkit-flex
    display: -ms-flex
    display: flex
    justify-content: space-between
    align-items: flex-start
    height: calc(100% - 85px)
    overflow: hidden
    z-index: -10
    transform: translateX(50px)
    opacity: 0
    visibility: hidden
    transition: all $transitSpeed
    &.is-active
      opacity: 1
      z-index: 10
      visibility: visible
      transform: translateX(0)
    &__mobile-data
      display: none
    &__info
      width: calc(100% - 235px)
      height: 100%
      overflow-y: auto
    &__back-mobile
      display: none
    &__how
      font-size: 16px
      margin-top: 0
      margin-bottom: 15px
      color: $text-18
    &__mobile-tabs
      display: none
      justify-content: space-around
      align-items: center
      margin-bottom: 25px
    &__mobile-tab
      font-size: 16px
      color: $text-18
      opacity: 0.5
      &.is-active
        opacity: 1
    &__wrap
      display: -webkit-flex
      display: -ms-flex
      display: flex
      justify-content: flex-start
      flex-wrap: wrap
      height: 0
      visibility: hidden
      opacity: 0
      transition: all $transitSpeed
      &.is-active
        height: auto
        visibility: visible
        opacity: 1
    &__title
      font-size: 18px
      margin-top: 0
      margin-bottom: 20px
      color: $text-18
      font-weight: bold
      position: relative
      &:hover
        cursor: pointer
      i
        position: absolute
        transition: all $transitSpeed
        top: 50%
        right: 0
        transform: translateY(-50%)
      &.is-active i
        transform: translateY(-50%) rotate(90deg)

    &__today,
    &__schedule
      margin-bottom: 25px
    &__today
      input
        display: none
        &:checked + label
          background-color: $text-36
          color: #fff
    &__time-wrap
      width: 40%
      margin-bottom: 10px
      margin-right: 10px
    &__time
      display: inline-block
      text-align: center
      font-size: 16px
      padding: 10px 20px
      border-radius: 8px
      transition: all $transitSpeed
      &:hover
        background-color: $text-36
        color: #fff
        cursor: pointer
    &__schedule
    .current-master__wrap
      justify-content: space-between
    &__days-wrap
      width: 40%
    &__days
      font-size: 16px
      text-transform: uppercase
      margin-bottom: 10px
      span
        margin-right: 20px
    &__text
      font-size: 16px
      line-height: 20px
      color: $text-18
      margin-top: 0
      margin-bottom: 20px
      height: 0
      visibility: hidden
      opacity: 0
      transition: all $transitSpeed
      &.is-active
        height: auto
        visibility: visible
        opacity: 1
    &__side
      height: 100%
      width: 230px
      display: -webkit-flex
      display: -ms-flex
      display: flex
      flex-direction: column
    &__back
      background-color: transparent
      padding: 0
      padding-right: 25px
      position: relative
      font-size: 16px
      color: $text-36
      border: 0
      margin-left: auto
      margin-bottom: 30px
      &:hover
        cursor: pointer
      i
        position: absolute
        top: 50%
        right: 0
        transform: translateY(-50%)
    &__buttons
      display: -webkit-flex
      display: -ms-flex
      display: flex
      justify-content: flex-end
      align-items: center
      margin-top: auto
    &__cancel
      text-align: center
      font-size: 16px
      margin-right: 20px
      color: $text-36
      background-color: transparent
      border: 0
      padding: 0
      &:hover
        cursor: pointer
    &__next
      text-align: center
      padding: 9px 15px
      color: #fff
      border-radius: 8px
      background-color: $text-36
      border: 1px solid transparent
      transition: all $transitSpeed
      &.is-disabled
        pointer-events: none
      &:hover
        cursor: pointer
        border: 1px solid $text-18
        color: $text-18
        background-color: #fff

  +r($desktop)
    .current-master
      padding: 20px
      &__info
        width: 100%
        padding-bottom: 40px
      &__side
        width: 0
      &__back
        position: absolute
        top: 20px
        right: 10px
      &__buttons
        position: absolute
        bottom: 10px
        right: 10px
        width: 100%
        background-color: rgba(255, 255, 255, 0.9)
        padding-top: 10px

  +r($tablet)
    .top-wrap-masters
      display: flex
      border-top-right-radius: 14px
      border-top-left-radius: 14px
      box-shadow: 0px -5px 15px rgba(0, 0, 0, 0.07)
      margin-top: 0
      margin-bottom: 0
      padding-top: 15px
      padding-bottom: 15px
      position: relative
      z-index: 0
      .container
        padding-left: 35px
      i
        display: inline-block
        font-size: 20px
      .top-wrap
        &__form
          display: none
        &__headers
          flex-wrap: wrap
          margin-right: 0
        &__title
          margin-bottom: 3px
          font-size: 14px
          color: #4D4D4D
    .client-masters
      position: relative
      z-index: 10
      .container
        height: calc(100vh - 150px)
        padding-left: 15px
        padding-right: 15px
      &__head
        padding-top: 0
        flex-wrap: wrap
        z-index: 2
        justify-content: flex-start
      &__subtitle,
      &__date
        font-size: 16px
      &__subtitle
        width: 100%
        margin-bottom: 10px
      &__date-label
        font-size: 15px
        margin-right: 10px
      &__slider
        flex-direction: column
        align-items: center
        margin-top: 30px
      &-item
        margin-bottom: 30px
    .vdpComponent.vdpWithInput > input
      font-size: 16px
      padding: 4px
    .current-master
      position: fixed
      top: 0
      left: 0
      width: 100%
      box-shadow: none
      height: 100%
      &.is-active
        transform: translateY(0px)
      &__mobile-data
        display: -webkit-flex
        display: -ms-flex
        display: flex
        justify-content: space-between
        -ms-align-items: flex-start
        align-items: center
        margin-bottom: 30px
      &__mobile-img
        display: block
        border-radius: 50%
        width: 50px
        height: 50px
        margin-right: 10px
        flex: 0 0 auto
      &__mobile-info
        flex-grow: 1
      &__mobile-name
        font-size: 16px
        font-weight: 600
        margin-top: 0
        margin-bottom: 10px
        color: $text-36
      &__mobile-serv
        font-size: 16px
        font-weight: 400
        margin: 0
        color: $text-36
      &__side
        display: block
      &__mobile-tabs
        display: flex
      &__back
        display: none
      &__how
        display: none
        text-align: center
        margin-bottom: 15px
      &__title
        display: none
      &__time
        margin-right: 0
        width: 100%
      &__wrap
        justify-content: space-between
        height: auto
        visibility: visible
        width: 100%
        opacity: 1
      &__schedule
        display: none
        margin-bottom: 0
        width: 100%
        &.is-active
          display: block
      &__about
        width: 100%
        display: none
        &.is-active
          display: block
      &__text
        height: auto
        visibility: visible
        opacity: 1
      &__days-wrap
        width: 100%
        text-align: center
      &__days
        display: flex
        justify-content: space-between
        -ms-align-items: center
        align-items: center
      &__today
        margin-bottom: 0
        width: 100%
        display: none
        &.is-active
          display: block
      &__info
        // height: auto
        overflow: auto
      // max-height: 300%
      //&__cancel
        display: none
      &__buttons
        justify-content: space-between
        right: 0
        padding: 10px 20px
      &__time
        padding: 10px 7px
      &__tab-wrap
        display: -webkit-flex
        display: -ms-flex
        display: flex
        -webkit-flex-direction: row
        -ms-flex-direction: row
        flex-direction: row
        -ms-align-items: flex-start
        align-items: flex-start
        justify-content: flex-start
        height: calc(100% - 150px)
        overflow-y: scroll

  +r($mobile)
    .client-masters
      &__head
        margin-bottom: 7px
      &__title
        font-size: 16px
      &__date
        font-size: 16px
        i
          font-size: 16px
        #triggerDate
          left: 0
          right: unset
      &__slider
        align-items: stretch

  @media(max-width: 767px)
    .client-masters-item
      &.single
        display: none
        z-index: 0

  @media(max-height: 600px)
    .client-masters-item
      &__img
        min-height: 200px
        max-height: 230px


</style>
